<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file AddonTickets.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  AddonTickets.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div v-if="tickets.length > 0" class="mb-2">
        <div>
            <!--            show the message to view addons-->
            <div class="h4-responsive text-left col-12 col-md-3 mb-1">
                <div class="mr-3">
                    <div>
                        <template v-if="show">
                            <span class="justify-content-end justify-content-md-start d-flex align-items-center cursor-pointer"
                                  v-on:click="show=!show"><span class="pr-2">Would you like these as well?</span> <i
                                    class="material-icons">closes</i></span>
                        </template>
                        <template v-else>
                            <span class="justify-content-end justify-content-md-start d-flex align-items-center cursor-pointer"
                                  v-on:click="show=!show"><span class="pr-2">Interested in more stuff</span> <i
                                    class="material-icons text-secondary">thumb_up</i></span>
                        </template>
                    </div>
                </div>
            </div>
            <transition-group name="slideLeft" tag="div"
                              class="transition-group row justify-content-start align-items-start">
                <div v-if="show"
                     :id="`${ticketSelectPrefix}${ticket.id}`"
                     v-for="ticket,index in tickets_compiled"
                     :key="ticket.id"
                     class="addon-ticket-selection col-12 col-md-6 col-lg-4 col-xl-3"
                >
                    <div class="card bg-primary">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-top">
                                <div>
                                    <InfoButton
                                            :active="ticket.show_info"
                                            @click="showInfo(index)"
                                    >
                                    </InfoButton>
                                </div>
                                <div>
                                    <div class="text-uppercase pr-1">
                                        <bold-words :word="{
                        text:lang('title',ticket.ticket_data.lang)
                        }"
                                        />
                                    </div>
                                    <small>{{lang('description.short',ticket.ticket_data.lang)}}</small>
                                </div>
                                <div>
                                    <button v-on:click="requestTicket(ticket)"
                                            class="btn d-flex justify-content-center align-items-center btn-info btn--with-icon m-0 position-relative btn-secondary"
                                    >
                                        <i aria-hidden="true"
                                           class="material-icons"
                                        >add_shopping_cart</i>
                                        <!---->
                                        <span data-element="button-price-wrapper">
                                <span class="text-body fs-7 lh-7">
                                    <span class="money--currency_number money--currency_number"
                                          v-html="formatMoney(ticket.price)"></span>
                                </span>
                            </span>
                                    </button>
                                </div>
                            </div>
                            <transition name="fade">
                                <template v-if="ticket.show_info">
                                    <TicketInfo
                                            class="mt-4"
                                            :ticket="ticket"
                                            :layout_vertical="false"
                                    ></TicketInfo>
                                </template>
                            </transition>
                        </div>
                    </div>
                </div>
            </transition-group>

        </div>
    </div>
</template>

<script>
    import BasketToastr from '../basket/BasketToastr.js';
    import BasketAddAnimation from '../basket/BasketAddAnimation.js';
    import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    import {format as formatMoney} from '../../../../../app/Shared/Resources/Assets/js/helpers/money';
    import {_} from 'underscore';
    import axios from 'axios';

    window.Vue.component('TicketInfo', require('./TicketInfo'));

    export default {
        name: "AddonTickets",
        mixins: [BasketToastr, BasketAddAnimation],
        props: {
            add_ticket_url: Object,
            tickets: {
                type: Array | Function,
                default: function () {
                    return [];
                }
            },
        },
        data() {
            return {
                tickets_compiled: [],
                ticketSelectPrefix: 'addon-ticket-selection--',
                show: true,
                tickets_clicked: [],
                toastr_last: {},
                toastr_options: {
                    newestOnTop: true,
                    progressBar: true,
                    timeOut: 6000,
                    positionClass: "toast-top-right",
                    showMethod: 'slideDown',
                    hideMethod: 'fadeOut',
                    showDuration: "150",
                },
            }
        },
        mounted() {
        },
        methods: {
            showInfo(index) {
                let self = this;

                self.compileTickets(false, index)
            },
            compileTickets(root, index) {
                let self = this;

                if (root === true ? self.tickets : self.tickets_compiled !== null) {
                    let tickets = root === true ? self.tickets : self.tickets_compiled;
// console.log(tickets)
                    for (let i = 0; i < tickets.length; i++) {
                        let ticket = tickets[i];
                        if (typeof index !== 'undefined' && i === index) {
                            ticket.show_info = !ticket.show_info;

                        } else {
                            tickets[i]['show_info'] = false;
                        }
                        self.$set(self.tickets_compiled, i, ticket);
                    }
                }
            },
            log() {
                console.log.apply(console, arguments);
            },
            ticketClicked(id) {
                this.$emit('ticket_clicked', id)
            },
            lang(path, object) {
                // console.log('object',object);
                return lang(path, object)
            },
            formatMoney(price) {
                return formatMoney(price, {
                    code: $('body').data('currency')
                });
            },
            requestTicket(ticket) {

                let self = this,
                    index = _.indexOf(self.tickets_clicked, ticket.id);

                // the item has already been requested and not yet returned a confirmation
                if (index >= 0) {
                    self.showToastr('warning', {message: 'please wait while we get your ticket'});
                    return false;
                } else {
                    if (self.isSoldOut(ticket) === true) {
                        self.showToastr('warning', {message: 'Ticket sold out'});
                        self.tickets_clicked = self.removeTicketFromWaitingList(ticket.id);
                        return false;
                    } else {
                        self.showToastr('info', {message: 'checking for available tickets'});

                        self
                            .addTicketToBasket(ticket)
                            .then(function (response) {
                                /**
                                 * @param {Boolean} response.data.sold_out
                                 * @param {Object} response.data
                                 * @namespace {Object} response
                                 * */
                                if (response.data.sold_out === true) {
                                    self.clearToastr(self.toastr_last);
                                    self.tickets_clicked = self.removeTicketFromWaitingList(ticket.id);
                                    self.showToastr('warning', {message: 'this ticket is sold out'});
                                } else if (response.data.exceeded === true) {
                                    let maxNumberOfTickets = response.data.limit;

                                    self.clearToastr(self.toastr_last);
                                    self.tickets_clicked = self.removeTicketFromWaitingList(ticket.id);
                                    self.showToastr('warning', {message: 'Only ' + maxNumberOfTickets + ' per purchase'});
                                } else {

                                    self.setAnimationComponent(
                                        self.ticketSelectPrefix,
                                        ticket,
                                        function () {
                                            // remove reserve from ticket adding process
                                            self.tickets_clicked
                                                = self
                                                .removeTicketFromWaitingList(ticket.id);
                                            // console.log('ticket',ticket)
                                            self.$basketController
                                                .$emit('read_basket', ticket.id);
                                            self.clearToastr();
                                        });
                                }
                            });
                    }
                }
            },
            isSoldOut(ticket) {
                return ticket.sale_content_counter_count > 0 && ticket.sale_content_counter_count > ticket.allocated;
            },

            async addTicketToBasket(ticket, callback) {
                let data = {};
                this.tickets_clicked.push(ticket.id);
                return await axios.post(`${this.add_ticket_url.data}/${ticket.id}`, data)
                    .then(function (response) {
                        return response;
                    })
                    .catch(function (e) {
                    });
            },
            removeTicketFromWaitingList(ticket_id) {
                let self = this,
                    index = _.indexOf(self.tickets_clicked, ticket_id);

                if (index > -1) {
                    self.$delete(self.tickets_clicked, index);
                }

                return self.tickets_clicked;
            },
            offset(el) {
                let rect = el.getBoundingClientRect(),
                    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                return {top: rect.top + scrollTop, left: rect.left + scrollLeft}
            }
        },
        watch: {
            tickets(tickets) {
                let self = this;

                self.compileTickets(true);
            }
        }
    }
</script>

<style scoped>

    @media (min-width: 768px) {
        .card-body {
            min-height: 160px;
        }
    }

    @media (max-width: 992px) {
        .addon-ticket-selection {
            margin-bottom: 1rem;
        }
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/tickets/AddonTickets.vue